module.exports = __webpack_public_path__ + "static/media/nav-icon-role-definition-inactive.03708ffe.svg";